import React, { Component } from 'react';
import Page from './page';


class Objectives extends Component {

    render() {
        return (
            <Page />
        );
    }
}
export default Objectives;